import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Shield } from 'lucide-react';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_140853a5-d37e-4724-8f64-c2f7eabb8728/artifacts/4msp2ofk_agrosvetlogo.png';

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#F8F8FC]" data-testid="privacy-policy-page">
      {/* Header */}
      <header className="sticky top-0 z-30 bg-white/80 backdrop-blur-xl border-b border-gray-100">
        <div className="max-w-3xl mx-auto flex items-center gap-3 px-4 py-3">
          <button onClick={() => navigate('/')} className="p-2 rounded-xl hover:bg-gray-100 transition-colors" data-testid="privacy-back-btn">
            <ArrowLeft size={20} className="text-gray-600" />
          </button>
          <img src={LOGO_URL} alt="AGROSVET" className="w-7 h-7 object-contain" />
          <span className="font-bold text-gray-900 text-sm">AGROSVET</span>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-3xl mx-auto px-4 py-8 sm:py-12">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-10 h-10 rounded-2xl bg-[#6b6de3]/10 flex items-center justify-center">
            <Shield size={20} className="text-[#6b6de3]" />
          </div>
          <div>
            <h1 className="text-2xl sm:text-3xl font-extrabold text-gray-900">Gizlilik Politikası</h1>
            <p className="text-sm text-[#8E8E93] mt-0.5">Son Güncelleme: 23 Mart 2026</p>
          </div>
        </div>

        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 sm:p-8 space-y-8" data-testid="privacy-content">
          <p className="text-gray-600 leading-relaxed">
            AgrosVet Veteriner Yönetim Yazılımı ("AgrosVet"), kullanıcılarının gizliliğine önem verir. Bu politika, agrosvet.app üzerinden sunulan hizmetlerde toplanan verilerin nasıl işlendiğini açıklar.
          </p>

          <section>
            <h2 className="text-lg font-bold text-gray-900 mb-3">1. Toplanan Veriler</h2>
            <p className="text-gray-600 mb-2">AgrosVet aşağıdaki verileri toplayabilir:</p>
            <ul className="space-y-1.5 text-gray-600">
              <li className="flex items-start gap-2"><span className="w-1.5 h-1.5 rounded-full bg-[#6b6de3] mt-2 shrink-0" />Kullanıcı bilgileri (ad, soyad, telefon, e-posta)</li>
              <li className="flex items-start gap-2"><span className="w-1.5 h-1.5 rounded-full bg-[#6b6de3] mt-2 shrink-0" />İşletme bilgileri (klinik adı, adres, vergi bilgileri)</li>
              <li className="flex items-start gap-2"><span className="w-1.5 h-1.5 rounded-full bg-[#6b6de3] mt-2 shrink-0" />Hasta (pet) bilgileri (isim, tür, ırk, yaş, sağlık kayıtları)</li>
              <li className="flex items-start gap-2"><span className="w-1.5 h-1.5 rounded-full bg-[#6b6de3] mt-2 shrink-0" />Pet sahiplerine ait iletişim bilgileri</li>
              <li className="flex items-start gap-2"><span className="w-1.5 h-1.5 rounded-full bg-[#6b6de3] mt-2 shrink-0" />Sistem kullanım verileri (log kayıtları, işlem geçmişi)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-900 mb-3">2. Verilerin Kullanım Amaçları</h2>
            <p className="text-gray-600 mb-2">Toplanan veriler:</p>
            <ul className="space-y-1.5 text-gray-600">
              <li className="flex items-start gap-2"><span className="w-1.5 h-1.5 rounded-full bg-[#6b6de3] mt-2 shrink-0" />Hizmetin sağlanması ve geliştirilmesi</li>
              <li className="flex items-start gap-2"><span className="w-1.5 h-1.5 rounded-full bg-[#6b6de3] mt-2 shrink-0" />Kullanıcı hesaplarının yönetimi</li>
              <li className="flex items-start gap-2"><span className="w-1.5 h-1.5 rounded-full bg-[#6b6de3] mt-2 shrink-0" />Veteriner süreçlerinin kayıt altına alınması</li>
              <li className="flex items-start gap-2"><span className="w-1.5 h-1.5 rounded-full bg-[#6b6de3] mt-2 shrink-0" />Teknik destek sağlanması</li>
              <li className="flex items-start gap-2"><span className="w-1.5 h-1.5 rounded-full bg-[#6b6de3] mt-2 shrink-0" />Yasal yükümlülüklerin yerine getirilmesi</li>
            </ul>
            <p className="text-gray-600 mt-2">amaçlarıyla kullanılır.</p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-900 mb-3">3. Veri Güvenliği</h2>
            <p className="text-gray-600 mb-2">AgrosVet, kişisel verilerin korunması için:</p>
            <ul className="space-y-1.5 text-gray-600">
              <li className="flex items-start gap-2"><span className="w-1.5 h-1.5 rounded-full bg-[#6b6de3] mt-2 shrink-0" />Güvenli sunucu altyapısı</li>
              <li className="flex items-start gap-2"><span className="w-1.5 h-1.5 rounded-full bg-[#6b6de3] mt-2 shrink-0" />Yetkilendirme ve erişim kontrol sistemleri</li>
              <li className="flex items-start gap-2"><span className="w-1.5 h-1.5 rounded-full bg-[#6b6de3] mt-2 shrink-0" />Şifreleme teknolojileri</li>
            </ul>
            <p className="text-gray-600 mt-2">kullanmaktadır.</p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-900 mb-3">4. Verilerin Paylaşımı</h2>
            <p className="text-gray-600 mb-2">Kişisel veriler:</p>
            <ul className="space-y-1.5 text-gray-600">
              <li className="flex items-start gap-2"><span className="w-1.5 h-1.5 rounded-full bg-[#6b6de3] mt-2 shrink-0" />Yasal zorunluluklar dışında üçüncü kişilerle paylaşılmaz</li>
              <li className="flex items-start gap-2"><span className="w-1.5 h-1.5 rounded-full bg-[#6b6de3] mt-2 shrink-0" />Teknik hizmet sağlayıcılarla (sunucu, e-posta vb.) sınırlı şekilde işlenebilir</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-900 mb-3">5. Veri Saklama Süresi</h2>
            <p className="text-gray-600 mb-2">Veriler:</p>
            <ul className="space-y-1.5 text-gray-600">
              <li className="flex items-start gap-2"><span className="w-1.5 h-1.5 rounded-full bg-[#6b6de3] mt-2 shrink-0" />Hizmet ilişkisi devam ettiği sürece</li>
              <li className="flex items-start gap-2"><span className="w-1.5 h-1.5 rounded-full bg-[#6b6de3] mt-2 shrink-0" />İlgili mevzuatta öngörülen süreler boyunca</li>
            </ul>
            <p className="text-gray-600 mt-2">saklanır, sonrasında silinir veya anonim hale getirilir.</p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-900 mb-3">6. Kullanıcı Hakları</h2>
            <p className="text-gray-600 mb-2">Kullanıcılar:</p>
            <ul className="space-y-1.5 text-gray-600">
              <li className="flex items-start gap-2"><span className="w-1.5 h-1.5 rounded-full bg-[#6b6de3] mt-2 shrink-0" />Verilerine erişme</li>
              <li className="flex items-start gap-2"><span className="w-1.5 h-1.5 rounded-full bg-[#6b6de3] mt-2 shrink-0" />Düzeltme talep etme</li>
              <li className="flex items-start gap-2"><span className="w-1.5 h-1.5 rounded-full bg-[#6b6de3] mt-2 shrink-0" />Silinmesini isteme</li>
            </ul>
            <p className="text-gray-600 mt-2">haklarına sahiptir.</p>
            <p className="text-gray-600 mt-3">
              İletişim: <a href="mailto:info@agrostech.net" className="text-[#6b6de3] font-medium hover:underline">info@agrostech.net</a>
            </p>
          </section>
        </div>
      </main>
    </div>
  );
};

export default PrivacyPolicy;
